import React from 'react'
import styled from 'styled-components'

const StyledDiv = styled.div`
  padding-left: 15px;
  padding-right: 15px;
  text-align: left;
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 10pt;
`

const StyledA = styled.a`
  margin-top: 5px;
  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
    cursor: pointer;
  }
  cursor: pointer;
  color: ${props => props.theme.colors.green1};
`

const OwnerInfoBox = props => {
  return (
    <StyledDiv>
      <div>
        <b>CREATOR</b>{' '}
      </div>
      <div>
        <StyledA href={`mailto:${props.ownerInfo}`}>{props.ownerInfo}</StyledA>
      </div>
    </StyledDiv>
  )
}

export default OwnerInfoBox
